import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CoachDataOptions, Option } from '../../types/user';
import { RootState } from '..';
import { transformToDropdownOptions } from '../../constant/utils/transformToDropdownOptions';

const initialState: CoachDataOptions = {
  coachEthnicityOptions: {
    _id: '',
    selections: {},
  },
  coachGenderOptions: {
    _id: '',
    selections: {},
  },
  coachSexualOrientationOptions: {
    _id: '',
    selections: {},
  },
};

export const coachDemographicSlice = createSlice({
  name: 'coachDemographics',
  initialState,
  reducers: {
    updateCoachGenderOptions: (state, action: PayloadAction<Option>) => {
      return {
        ...state,
        coachGenderOptions: action.payload,
      };
    },
    updateCoachEthnicityOptions: (state, action: PayloadAction<Option>) => {
      return {
        ...state,
        coachEthnicityOptions: action.payload,
      };
    },
    updateCoachSexualOrientationOptions: (state, action: PayloadAction<Option>) => {
      return {
        ...state,
        coachSexualOrientationOptions: action.payload,
      };
    },
    clearCoachDemographicOptions: () => initialState,
  },
});

export const {
  updateCoachGenderOptions,
  updateCoachEthnicityOptions,
  updateCoachSexualOrientationOptions,
  clearCoachDemographicOptions,
} = coachDemographicSlice.actions;

export default coachDemographicSlice.reducer;


const getCoachGenderOptions = (state: RootState) => state.coachDemographics.coachGenderOptions;
const getCoachEthnicityOptions = (state: RootState) => state.coachDemographics.coachEthnicityOptions;
const getCoachSexualOrientationOptions = (state: RootState) => state.coachDemographics.coachSexualOrientationOptions;

// Memoized selectors that only recalculate when their inputs change
export const selectCoachGenderDropdownOptions = createSelector([getCoachGenderOptions], (genderOptions) =>
  transformToDropdownOptions(genderOptions)
);


export const selectCoachEthnicityDropdownOptions = createSelector(
  [getCoachEthnicityOptions],
  (ethnicityOptions) => transformToDropdownOptions(ethnicityOptions)
);

export const selectCoachSexualOrientationDropdownOptions = createSelector(
  [getCoachSexualOrientationOptions],
  (sexualOrientationOptions) => transformToDropdownOptions(sexualOrientationOptions)
);
